import { makeEventFunctions } from '@deephaven/golden-layout';
/**
 * Events emitted by panels and to control panels
 */
export var PanelEvent = Object.freeze({
  // Panel has received focus
  FOCUS: 'PanelEvent.FOCUS',
  // Panel has been mounted
  MOUNT: 'PanelEvent.MOUNT',
  // Panel has been unmounted
  UNMOUNT: 'PanelEvent.UNMOUNT',
  // The title of the panel has changed
  TITLE_CHANGED: 'PanelEvent.TITLE_CHANGED',
  // Panel was re-opened from a dehydrated state
  REOPEN: 'PanelEvent.REOPEN',
  // Reopen last closed panel
  REOPEN_LAST: 'PanelEvent.REOPEN_LAST',
  // Panel was deleted
  DELETE: 'PanelEvent.DELETE',
  // Panel was cloned/copied
  CLONED: 'PanelEvent.CLONED',
  // Panel was closed
  CLOSED: 'PanelEvent.CLOSED',
  // Event to open a new panel
  // Plugins will need to register to open based on this event.
  // Multiple plugins could open panels for the same event if desired.
  OPEN: 'PanelEvent.OPEN',
  // Event to close a panel that's currently open
  CLOSE: 'PanelEvent.CLOSE',
  // Panel is being dragged
  DRAGGING: 'PanelEvent.DRAGGING',
  // Panel is dropped
  DROPPED: 'PanelEvent.DROPPED'
});
var _makeEventFunctions = makeEventFunctions(PanelEvent.OPEN),
  listenForPanelOpen = _makeEventFunctions.listen,
  emitPanelOpen = _makeEventFunctions.emit,
  usePanelOpenListener = _makeEventFunctions.useListener;
export { listenForPanelOpen, emitPanelOpen, usePanelOpenListener };
var _makeEventFunctions2 = makeEventFunctions(PanelEvent.CLOSE),
  listenForPanelClose = _makeEventFunctions2.listen,
  emitPanelClose = _makeEventFunctions2.emit,
  usePanelCloseListener = _makeEventFunctions2.useListener;

// TODO (#2147): Add the rest of the event functions here. Need to create the correct types for all of them.
export { listenForPanelClose, emitPanelClose, usePanelCloseListener };
export default PanelEvent;
//# sourceMappingURL=PanelEvent.js.map